import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { Provider } from 'mobx-react'

import stores from './stores'
import Navigators from './navigators'

class App extends React.Component {
  componentDidMount () {
    if (!window.location.protocol === 'http') {
      window.location.href = 'https' + window.location.href.slice(4)
    }
  }

  render () {
    const context = {
      ssr: false
    }

    return (
      <Provider store={stores} {...stores}>
        <BrowserRouter context={context}>
          <Switch>
            <Redirect from='/login' to='/auth/login' />
            <Redirect from='/signup' to='/auth/signup' />

            <Route path='/dashboard' component={Navigators.Dashboard} />
            <Route path='/auth' component={Navigators.Auth} />
            <Route path='/' component={Navigators.Home} />
          </Switch>
        </BrowserRouter>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js